import React from 'react';
import './CartItem.css';

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  const handleQuantityChange = (newQuantity) => {
    onUpdateQuantity(item.cartId, newQuantity);
  };

  return (
    <div className="cart-item">
      <div className="item-header">
        <h4 className="item-name">{item.name}</h4>
        <span className="item-price">${(item.price * item.quantity).toFixed(2)}</span>
      </div>
      
      <div className="item-details">
        <p>Size: {item.size}</p>
        <p>Sweetness: {item.sweetness}</p>
        <p>Takeaway: {item.takeaway ? 'Yes' : 'No'}</p>
      </div>
      
      <div className="item-actions">
        <div className="quantity-controls">
          <button 
            className="quantity-btn"
            onClick={() => handleQuantityChange(item.quantity - 1)}
          >
            -
          </button>
          <span className="quantity">{item.quantity}</span>
          <button 
            className="quantity-btn"
            onClick={() => handleQuantityChange(item.quantity + 1)}
          >
            +
          </button>
        </div>
        
        <button 
          className="delete-btn"
          onClick={() => onRemove(item.cartId)}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default CartItem;